<template>
    <div>
        <v-select
            v-model="id"
            :rules="rules"
            :items="currencies"
            dense
            item-text="abbreviation"
            :menu-props="{down: true,offsetY: true}"
            item-value="id"
            :label="$t('currency')"
            v-on="$listeners"
            v-bind="$props"
            >
        </v-select>
        <retry-dialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit">
        </retry-dialog>
    </div>
</template>

<script>
import { mapActions,mapState } from 'vuex'
import RetryDialog from './RetryDialog.vue';
export default {
    name: "PCurrencySelect",
    props: {
        value: Number,
        rules: Array,
        hide: Boolean,
        backgroundColor: String,
        outlined: Boolean,
        hideDetails: [String, Boolean]
    },
    components: {
        RetryDialog
    },
    data() {
        return {}
    },
    computed: {
        ...mapState('accounting/currency',["currencies"]),
         id: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    watch: {
        id: {
            handler() {
                if(this.id) {
                    let abbreviation = this.currencies.find(each => each.id == this.id).abbreviation;
                    this.$emit('get:abbreviation', abbreviation);
                } 
            }
        }
    },
    methods: {
        ...mapActions('accounting/currency', ["fetchCurrencies"]),
        async createdDataFetch() {
            try {
                await this.fetchCurrencies();
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"createdDataFetch",message});
            }
        },
        onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
            }
        },
    },
    created() {
        this.createdDataFetch();
    }
}
</script>

<style>

</style>